module.exports = __webpack_public_path__ + "img/ma.13419aa9.jpeg";